export interface NameFormValues {
    firstName: string;
    middleName: string;
    lastName: string;
}
